import React, { useState } from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { AllergyType, DrugType, PropsSmartFieldLocalized } from './index';
import DrugSelector from './DrugSelector';
import { Grid } from '@mui/material';
import { ButtonCancel, ButtonContinue } from '../mini_components';
import { Alert } from '@mui/material';
import { makeNoKnownAllergy } from '../../../constants';

interface AllergyProps extends PropsSmartFieldLocalized {
    /**
     * SHER-1057: whether "No known allergies" may be offered here — false while the
     * patient has documented allergies, is already "no known", or an allergy was
     * entered in this form. Defaults to true for hosts that do not know the state.
     */
    offerNoKnown?: boolean;
}

function Allergy(props: AllergyProps) {
    const [drug, setDrug] = useState<DrugType | null>(null);
    const [error, setError] = useState<boolean>(false);

    function drugSelected(drug:DrugType){
        setDrug(drug);
        const allergy:AllergyType={
            allergy:drug.name,
            "compo-code":drug.id
        }
        props.elementSelected(allergy);
    }

    // SHER-263: record "reviewed, no known allergies". Stored as a normal allergy whose value
    // is the reserved NAMC sentinel so the API recompute reports the Clinical Summary green
    // state instead of listing it as a real allergy.
    function noKnownAllergiesSelected(){
        props.elementSelected(makeNoKnownAllergy());
    }
    
    if(error){
        return(
            <Alert severity="error">
                <Translate id="investigation.share.error.description" />
            </Alert>);
    }
    return(
        <Grid container spacing={0}>
            <Grid xs={12}>
                <DrugSelector type={props.type} variant={props.variant} error={error || props.error} 
                    callbackError={(error) => setError(error)}  
                    freeSolo
                    chemicalComponent country={props.country as string}
                    drugSelected={(drug) => drugSelected(drug)} />
            </Grid>
            <Grid xs={12} style={{paddingTop:'1rem'}}>
                <ButtonCancel onClick={props.cancel} ><Translate id="general.cancel" /></ButtonCancel>
                {props.offerNoKnown !== false && (
                    <>
                        &nbsp;
                        <ButtonContinue data-testid="no-known-allergies" onClick={noKnownAllergiesSelected} color="green">
                            <Translate id="clinicalSummary.allergy.noKnown" />
                        </ButtonContinue>
                    </>
                )}
            </Grid>
            
        </Grid>
        
    )
}

export default withLocalize(Allergy);